import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm, useField } from 'react-final-form';
import strings from 'localization/strings';

import StripePaymentField from '../stripe/StripePaymentField';
import Box from '@material-ui/core/Box';
import MarginBox from 'common/MarginBox';
import Typography from '@material-ui/core/Typography';
import { Radios, Checkboxes } from 'mui-rff';

const StripePaymentElement = ({ name, stripePaymentContext, stripeSetupContext }) => {
    const form = useForm();
    const getName = suffix => suffix ? `${name}.${suffix}` : name;
    const getValue = suffix => useField(getName(suffix)).input.value;
    const paymentMethodId = getValue('paymentMethodId');
    const selectableSavedPaymentMethods = stripePaymentContext?.selectableSavedPaymentMethods ?? stripeSetupContext?.selectableSavedPaymentMethods;
    const hasSelectableSavedPaymentMethods = selectableSavedPaymentMethods?.length > 0;
    const hasMultipleActivePaymentMethods = stripePaymentContext?.hasMultipleActivePaymentMethods ?? stripeSetupContext?.hasMultipleActivePaymentMethods;
    const allowSavePaymentMethod = stripePaymentContext?.allowSavePaymentMethod ?? stripeSetupContext?.allowSavePaymentMethod;
    const showUseForAllPaymentsCheckbox =
        allowSavePaymentMethod
        &&
        (hasMultipleActivePaymentMethods || (hasSelectableSavedPaymentMethods && paymentMethodId === 'other'));

    useEffect(() => {
        if(hasSelectableSavedPaymentMethods) {
            form.change(getName('paymentMethodId'), selectableSavedPaymentMethods[0].paymentMethodId);
        } else {
            form.change(getName('paymentMethodId'), 'other');
        }
    }, [selectableSavedPaymentMethods]);

    const paymentMethodItems = (selectableSavedPaymentMethods ?? [])
        .map(paymentMethod => ({
            label: `${strings.payWithSavedPaymentMethod}: ${strings.formatString(strings.protectedCardDetails, paymentMethod.last4, paymentMethod.expirationMonth, paymentMethod.expirationYear)}`,
            value: paymentMethod.paymentMethodId
        }))
        .concat([{
            label: strings.payWithOtherPaymentMethod,
            value: 'other'
        }]);

    return (
        <>
            {
                hasSelectableSavedPaymentMethods &&
                (
                    <Box>
                        <Typography variant="h5" gutterBottom>
                            {strings.selectPaymentMethod}
                        </Typography>
                        <Radios
                            name={getName('paymentMethodId')}
                            data={paymentMethodItems}
                        />
                    </Box>
                )
            }

            {
                !hasSelectableSavedPaymentMethods &&
                (
                    <Typography variant="h5" gutterBottom>
                        {stripeSetupContext ? strings.newPaymentMethod : strings.paymentMethod}
                    </Typography>
                )
            }
            <StripePaymentField
                visible={paymentMethodId === 'other'}
            />

            {
                showUseForAllPaymentsCheckbox &&
                (
                    <MarginBox top={4}>
                        <Checkboxes
                            name={getName('useForAllPayments')}
                            data={{
                                label: strings.usePaymentMethodForAllPayments,
                                value: true
                            }}
                        />
                    </MarginBox>
                )
            }
        </>
    );
};

StripePaymentElement.propTypes = {
    name: PropTypes.string.isRequired,
    stripePaymentContext: PropTypes.object,
    stripeSetupContext: PropTypes.object
};

export default StripePaymentElement;
